import React, { Component } from "react";
import { push } from "../Analytics"
import "./FlowPlayer.scss"

// var VIDEO = "";
// const VIDEO_URL = {
//     callback: VIDEO,
//     desktop: VIDEO.replace("mediadownload.ynet.co.il", "ynethd-i.akamaihd.net"),
//     mobile: VIDEO.replace("mediadownload.ynet.co.il", "vod.ynet-cdnwiz.com")
// }

class FlowPlayer extends Component {
    constructor() {
        super();
        this.isMobile = this.isMobile.bind(this);
        this.embedVideo = this.embedVideo.bind(this);
        this.state = {
            source: []
        }
    }
    isMobile() {
        if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        } else {
            return false;
        }
    }
    async componentDidMount() {
        this.setState({
            source: this.props
        });
        await this.embedVideo();
    }
    embedVideo() {
        var container = this.player;
        window.flowplayer.conf = {
            fullscreen: true,
            splash: (this.props.autoplay ? false : true)
        }

        var videoIndex;
        if (window.location.href) {
            var url = new URL(window.location.href);
            // var c = url.searchParams.get("video");
            // videoIndex = window.location.href.split("-")[1];
            videoIndex = url.searchParams.get("video");
            if (Number(videoIndex) % 1 === 0) {
                videoIndex = Number(videoIndex);
            }
        }
        window.flowplayer((api, root) => {
            var fsbutton = root.querySelector(".fp-fullscreen");

            if (this.isMobile()) {
                container.addEventListener("click", () => {
                    api.fullscreen();
                });
            }
            if (!this.isMobile()) {
                api.on("ready", () => {
                    root.querySelector(".fp-controls").appendChild(fsbutton);
                });
            }
            // api.on("ready", () => {
            //     if (this.player.className.indexOf("is-paused") < 0) {
            //         this.player.querySelector(".fp-volumebtn").addEventListener("click", () => {
            //             if (this.player.className.indexOf("is-muted") < 0) {
            //                 push("Video_UnMute", this.props.videoName);
            //             } else {
            //                 push("Video_Mute", this.props.videoName);
            //             }
            //         });
            //     }
            // })
            // root.querySelector(".fp-controls")
            // root.querySelector(".fp-volumebtn").addEventListener("click", () => {
            //     if (root.className.indexOf("is-muted") < 0) {
            //         push("Video_Mute", this.props.videoName)
            //     } else {
            //         push("Video_UnMute", this.props.videoName);
            //     }
            // });
            // api.on("mute", () => {
            //     if(root.className.indexOf("is-muted") < 0)  {
            //         console.log("unmuted");
            //     } else{
            //         console.log("muted");
            //     }
            // });
        });
        window.flowplayer(container, {
            key: '$858384515984319,$509034830680622,$968022418025930,$104200519403602,$955543217793552,$112133720880866,$508506330648762,$509034830680622,$664969740079151,$574051834599330,$617925037243662',
            muted: true,
            startIndex: videoIndex || 0,
            analytics: "UA-5536870-34",
            fullscreen: true,
            native_fullscreen: true,
            ratio: 9 / 16,
            buffering: false,
            mouseoutTimeout: 1500,
            share: false,
            splash: (this.props.autoplay ? false : true),
            hlsjs: {
                maxMaxBufferLength: 60
            },
            loop: true,
            autoplay: (this.props.autoplay ? this.props.autoplay : false),
            clip: this.props.list[(videoIndex+1 == this.props.list.length ? videoIndex : 0)],
            playlist: (this.props.list.length > 1 ? this.props.list : this.props.list[0])
        }).on("ready", (e, api, video) => {
            // if (this.player.className.indexOf("is-paused") < 0) {
            //     this.player.querySelector(".fp-volumebtn").addEventListener("click", () => {
            //         if (this.player.className.indexOf("is-muted") < 0) {
            //             push("Video_UnMute", this.props.videoName);
            //         } else {
            //             push("Video_Mute", this.props.videoName);
            //         }
            //     });
            // }
        }).on("pause", (e, api, video) => {
            push("Video Paused", this.props.list[(videoIndex+1 == this.props.list.length ? videoIndex : 0)].sources[0].src);
        }).on("resume", (e, api, video) => {
            push("Video Played", this.props.list[(videoIndex+1 == this.props.list.length ? videoIndex : 0)].sources[0].src);
        });
    }
    render() {
        return (
            <div id={`player_${Math.random()}`} ref={(player) => { this.player = player }} data-autoplay={(this.props.autoplay ? this.props.autoplay : false)} data-loop="true" className="flowplayer fp-full fixed-controls play-button fp-mute"></div>
        );
    }
}

export default FlowPlayer;


// WEBPACK FOOTER //
// ./src/Components/Services/FlowPlayer/FlowPlayer.jsx